export const API_GET_HOME_CARD = 'v2/course/campaign/homeCard';
export const API_GET_INSIDE_TABS = 'v2/course/campaign/influencerInfo';

export const API_DEEPLINK = 'v2/storeDeeplink';
